import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=1c667e44&scoped=true&"
import script from "./Record.vue?vue&type=script&lang=js&"
export * from "./Record.vue?vue&type=script&lang=js&"
import style0 from "./Record.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Record.vue?vue&type=style&index=1&id=1c667e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c667e44",
  null
  
)

export default component.exports